import worldMap from "../../../assets/icons/worldMap.svg";

const RightSection = () => {
  return (
    <div className="flex-1 bg-gradient-to-br flex-col justify-center px-12 relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-primary-cyan/20 rounded-full animate-float"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${3 + Math.random() * 5}s`,
            }}
          />
        ))}
      </div>

      <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-primary-cyan/10 rounded-full blur-3xl animate-pulse-slow"></div>
      <div className="absolute bottom-1/3 left-1/3 w-80 h-80 bg-primary-cyan/5 rounded-full blur-3xl animate-pulse-slow animation-delay-1000"></div>

      <div className="relative z-10 animate-slide-up">
        <h1 className="text-7xl font-bold text-white leading-tight mb-4">
          Intelligent Cloud
          <span className="text-primary-cyan relative">
            {" "}
            Operations Platform
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-primary-cyan scale-x-0 animate-expand-width origin-left"></span>
          </span>
        </h1>

        <div className="w-20 h-1 bg-primary-cyan mb-6 rounded-full animate-expand-width"></div>

        <p className="text-gray-300 text-lg mb-12 leading-relaxed max-w-2xl animate-slide-up animation-delay-200">
          AI-powered performance monitoring, enhanced security, and smart
          troubleshooting for modern enterprises
        </p>
      </div>

      <div className="flex justify-center">
        <div className="rounded-xl   p-2   group inline-flex">
          <div className="relative   rounded-lg overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>

            <img
              src={worldMap}
              alt="Global Infrastructure Map"
              className="w-[600px] h-[300px] block "
              
            />

            <div className="absolute top-1/3 left-1/3 w-2 h-2 bg-primary-cyan rounded-full animate-ping"></div>
            <div className="absolute top-2/4 left-1/2 w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
            <div className="absolute top-1/2 left-2/3 w-2 h-2 bg-yellow-400 rounded-full animate-ping animation-delay-1000"></div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%,
          100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes expand-width {
          from {
            transform: scaleX(0);
          }
          to {
            transform: scaleX(1);
          }
        }

        .animate-float {
          animation: float 3s ease-in-out infinite;
        }

        .animate-pulse-slow {
          animation: pulse 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }

        .animate-slide-up {
          animation: slide-up 0.6s ease-out forwards;
          opacity: 0;
        }

        .animate-expand-width {
          animation: expand-width 0.8s ease-out forwards;
        }

        .animation-delay-200 {
          animation-delay: 200ms;
        }
        .animation-delay-400 {
          animation-delay: 400ms;
        }
        .animation-delay-1000 {
          animation-delay: 1000ms;
        }
      `}</style>
    </div>
  );
};

export default RightSection;